import React from "react";
import { GrSearch } from "react-icons/gr";
import Checkbox from "../Forms/Checkbox";
import Colorcheckbox from "../Forms/Colorcheckbox";
import {AiOutlineMinus} from 'react-icons/ai';
import Dropdown from "../Buttons/Dropdown";
const Shopfilter = () => {
  return (
    <div className="w-full border border-gray-300">
      <div className="w-full flex justify-between items-center ">
        <h1 className=" py-4 px-4 text-lg text-jet font-bold  border-transparent ">
          FILTERS
        </h1>
        <h1 className=" py-2 px-3  text-sm text-rose-500 font-semibold  border-transparent ">
          CLEAR ALL
        </h1>
      </div>
       
      <div id="Category" className="w-full  flex flex-col  border border-b-gray-300 border-transparent ">
        <h1 className="px-2 font-bold text-sm text-jet ">CATEGORIES</h1>
        <div className="p-2 ">
            <Dropdown name={'Fruites & Vegitables '} content={['Fresh Fruites','Fresh vegitables','Herbs & Seasoning','Herbs & Seasoning','Herbs & Seasoning']} />
            <Dropdown name={'Premium Fruites '} content={['Fresh Fruites','Fresh vegitables','Herbs & Seasoning','Herbs & Seasoning','Herbs & Seasoning']} />
            <Dropdown name={'Diary & Bakery '} content={['Fresh Fruites','Fresh vegitables','Herbs & Seasoning','Herbs & Seasoning','Herbs & Seasoning']} />
            <Dropdown name={'Staples '} content={['Fresh Fruites','Fresh vegitables','Herbs & Seasoning','Herbs & Seasoning','Herbs & Seasoning']} />
            <Dropdown name={'Sbnacks & Branded foods '} content={['Fresh Fruites','Fresh vegitables','Herbs & Seasoning','Herbs & Seasoning','Herbs & Seasoning']} />
            <Dropdown name={'Beverages '} content={['Fresh Fruites','Fresh vegitables','Herbs & Seasoning','Herbs & Seasoning','Herbs & Seasoning']} />
            <Dropdown name={'Personal Care '} content={['Fresh Fruites','Fresh vegitables','Herbs & Seasoning','Herbs & Seasoning','Herbs & Seasoning']} />
            <Dropdown name={'Home Care '} content={['Fresh Fruites','Fresh vegitables','Herbs & Seasoning','Herbs & Seasoning','Herbs & Seasoning']} />
            <Dropdown name={'Apparel '} content={['Fresh Fruites','Fresh vegitables','Herbs & Seasoning','Herbs & Seasoning','Herbs & Seasoning']} />
            <Dropdown name={'Home & Kitchen '} content={['Fresh Fruites','Fresh vegitables','Herbs & Seasoning','Herbs & Seasoning','Herbs & Seasoning']} />
            <Dropdown name={'Books '} content={['Fresh Fruites','Fresh vegitables','Herbs & Seasoning','Herbs & Seasoning','Herbs & Seasoning']} />
        </div>
      </div> 

      <div
        id="Brand"
        className="w-full  flex flex-col  border border-b-gray-300 border-transparent "
      >
        <div className="w-full flex justify-between items-center ">
          <h1 className=" py-2 px-4 text-sm text-jet font-bold  border-transparent ">
            BRAND
          </h1>
          <h1 className=" py-2 px-4  text-sm  border-transparent ">
            <button className=" p-2 border border-gray-200 rounded-full bg-gray-100 ">
              <GrSearch />
            </button>
          </h1>
        </div>

        <div id="brand" className="w-full pt-2 px-4 pb-4  ">
          <Checkbox Name={"Wildcraft"} />
          <Checkbox Name={"F Gear"} />
          <Checkbox Name={"Puma"} />
          <Checkbox Name={"Harrisons"} />
          <Checkbox Name={"HRX by Hritik"} />
          <Checkbox Name={"Zwart"} />
          <Checkbox Name={"Gear"} />
          <Checkbox Name={"Provogue"} />
          <Checkbox Name={"Gear"} />
        </div>
      </div>


      <div
        id="Color"
        className="w-full  flex flex-col  border border-b-gray-300 border-transparent "
      >
        <div className="w-full flex justify-between items-center ">
          <h1 className=" py-2 px-4 text-sm text-jet font-bold  border-transparent ">
            COLOR
          </h1>
          <h1 className=" py-2 px-4  text-sm  border-transparent ">
            <button className=" p-2 border border-gray-200 rounded-full bg-gray-100 ">
              <GrSearch />
            </button>
          </h1>
        </div>

        <div id="brand" className="w-full  px-4 pb-4  ">
         <Colorcheckbox color={"bg-rose-500"} name={"Rose"} />
         <Colorcheckbox color={"bg-blue-700"} name={"Blue"} />
         <Colorcheckbox color={"bg-green-600"} name={"Green"}/>
         <Colorcheckbox color={"bg-sky-500"} name={"Sky"} />
         <Colorcheckbox color={"bg-yellow-500"} name={"Yellow"} />
         <Colorcheckbox color={"bg-orange-600"} name={"Orange"} />
         <Colorcheckbox color={"bg-black"} name={"Black"}/>
         <Colorcheckbox color={"bg-red-600"} name={"Red"}/>
         <Colorcheckbox color={"bg-pink-600"} name={"Pink"}/>
        </div>
      </div>


      <div
        id="Price"
        className="w-full pb-4 flex flex-col  border border-b-gray-300 border-transparent "
      >
        <div className="w-full flex justify-between items-center ">
          <h1 className=" py-2 px-4 text-md text-jet font-semibold  border-transparent ">
            PRICE
          </h1>
         
        </div>

        <div id="brand" className="w-full flex justify-between items-center px-1   ">
        <div className="relative w-5/12 ">
    <input type="text" id="floating_outlined" className="block px-2.5 pb-2 pt-2 w-full text-sm text-gray-900 bg-transparent rounded-sm border border-gray-300 appearance-none  focus:outline-none focus:ring-0 focus:border-rose-500 peer" placeholder=" " />
    <label for="floating_outlined" className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white  px-2 peer-focus:px-2 peer-focus:text-rose-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Max</label>
</div>
<div><AiOutlineMinus/></div>
<div className="relative basis-5/12 ">
    <input type="text" id="floating_outlined" className="block px-2.5 pb-2 pt-2 w-full text-sm text-gray-900 bg-transparent rounded-sm border border-gray-300 appearance-none  focus:outline-none focus:ring-0 focus:border-rose-600 peer" placeholder=" " />
    <label for="floating_outlined" className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white  px-2 peer-focus:px-2 peer-focus:text-rose-600  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Min</label>
</div>
        </div>
      </div>
    </div>
  );
};

export default Shopfilter;
